module.exports = __webpack_public_path__ + "img/dashboard.b9498b96.png";